const topHeader = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    const header = document.querySelector('#jsHeader');

    let tl = gsap.timeline({
      scrollTrigger: {
        invalidateOnRefresh: true,
        trigger: 'body',
        start: "1% 0%",
        end: "100% 0%",
        toggleClass: { targets: header, className: "act" },
        // markers: true,
      },
    })

    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        tl.scrollTrigger.refresh()
      });
    });
    observer.observe(target);



  }
})()
export default topHeader;